import { ReactElement, useEffect, FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isDispatched, isPending } from "@ctra/utils";
import { Enterprise, User, UserList, EnterpriseAppState } from "@ctra/api";

interface UserListProviderProps {
  children: (users: UserList, meta: { isLoading: boolean }) => ReactElement | null;
}

/**
 * Fetch user list
 * @param children
 * @constructor
 * @deprecated in favor of UserListContext
 */
export const UserListProvider: FC<UserListProviderProps> = ({ children }) => {
  const dispatch = useDispatch();

  /**
   * Get all the users of the app (excluding the current one)
   */
  const users = useSelector<EnterpriseAppState, UserList>(Enterprise.entities.getUserList);

  /**
   * Tell whether the fetching action has been dispatched
   */
  const dispatched = useSelector<EnterpriseAppState, boolean>((state) =>
    isDispatched(state, User.types.FETCH_USER_LIST, { primaryValue: -1 })
  );

  /**
   * Tell if the data request is in progress
   */
  const isLoading = useSelector<EnterpriseAppState, boolean>((state) =>
    isPending(state, User.types.FETCH_USER_LIST, { primaryValue: -1 })
  );

  useEffect(() => {
    if (!dispatched) {
      dispatch(User.actions.fetchUserList.start());
    }
  }, [dispatch, dispatched, users]);

  return children(users, { isLoading: !dispatched || isLoading });
};
